import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Search } from "@material-ui/icons";
import Pagination from "@material-ui/lab/Pagination";

import useDebounce from "../../components/Control/useDebounce";
import { useAuth } from "../../context/GlobalContext";
import Modal from "../../components/Control/Modal";
import formatDate from "../../components/Control/formatDate";
import { Wrapper } from "../../components/Control/Flexbox";
import Input from "../../components/Control/Input";
import useConfirm from "../../components/Control/useConfirm";
import MasterProcedureInputs from "./MasterProcedureInputs";
import { options } from "./helpers";
import { useQuery } from "../../components/Control/useQuery";

const useStyles = makeStyles({
  table: {
    width: "100%",
    marginTop: "1.5rem",
    backgroundColor: "white",
  },
});

const MasterProcedureList = () => {
  const { state } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const [dataControlData, setDataControlData] = useState();
  const userType = state.user.userType;
  const [currentId, setCurrentId] = useState(null);
  const [render, setRender] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState();
  const [filter, setFilter] = useState("");
  const query = useQuery();
  const category = query.get("category");
  const [DialogDelete, confirmDelete] = useConfirm(
    "DELETE",
    "Are you sure you want to Delete this Document?"
  );

  const fetchDrawingData = () => {
    axios
      .get(
        `/api/getMasterProcedure?page=${page}&category=${
          filter || category
        }&search=${search}&perPage=10`
      )
      .then((res) => {
        setPerPage(res.data?.perPage);
        setDataControlData(res.data?.results);
        setTotalPages(res.data?.pages);
      })
      .catch((err) => console.log(err));
  };
  useDebounce(fetchDrawingData, 300, [page, filter, search, render, openModal]);

  const handleDelete = async (id) => {
    const confirm = await confirmDelete();
    if (confirm) {
      axios
        .delete(`/api/deleteMasterProcedure/${id}`)
        .then((res) => {
          alert("Document deleted successfully");
          setRender((prev) => !prev);
        })
        .catch((err) => console.log(err));
    }
  };

  const classes = useStyles();
  return (
    <section>
      <div style={{ paddingBottom: "3rem" }}>
        <div
          className="divflex"
          style={{
            fontSize: "24px",
          }}
        >
          MASTER LIST OF PROCEDURE
          <div className="text">
            <p style={{ marginRight: "1rem" }}>
              <span style={{ fontWeight: "600", fontSize: "14px" }}></span>
            </p>
          </div>
          {userType === 2 && (
            <Button
              variant="contained"
              color="primary"
              size="large"
              style={{
                backgroundColor: "#054a29",
              }}
              startIcon={<AddCircleIcon />}
              onClick={() => {
                setOpenModal(true);
                setCurrentId(null);
              }}
            >
              Upload New Files
            </Button>
          )}
        </div>
        <div className="subheading-container">
          <p className="subheading-primary">
            ACTIVE <span className="subheading-secondary">Documents</span>
          </p>
        </div>
        <Wrapper>
          <div style={{ flex: "0.9" }}>
            <Input
              placeholder="Search By Document Name"
              variant="filled"
              style={{
                width: "96%",
                marginLeft: "1.2rem",
                marginTop: "1rem",
              }}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <FormControl
            variant="filled"
            className="select-field"
            style={{ marginRight: "1.5rem", marginTop: "0.8rem", flex: "0.1" }}
          >
            <InputLabel>Filter</InputLabel>
            <Select
              name="filter"
              onChange={(e) => setFilter(e.target.value)}
              defaultValue={filter || category}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Wrapper>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow style={{ padding: "6px" }}>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                #
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Document Name
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Document Type
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Document Description
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Date
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          {dataControlData && (
            <TableBody>
              {dataControlData.map((item, index) => (
                <React.Fragment key={item._id}>
                  <TableRow>
                    <TableCell align="center">
                      {perPage * (page - 1) + index + 1}
                    </TableCell>
                    <TableCell align="center">{item.document_name}</TableCell>
                    <TableCell align="center">{item.document_type}</TableCell>
                    <TableCell align="center">
                      {item.document_description}
                    </TableCell>
                    <TableCell align="center">
                      {formatDate(item.createdAt)}
                    </TableCell>

                    <TableCell align="center">
                      {userType === 2 && (
                        <Tooltip title="Edit" arrow>
                          <IconButton
                            size="small"
                            style={{ marginRight: "0.5rem" }}
                            onClick={() => {
                              setCurrentId(item._id);
                              setOpenModal(true);
                            }}
                          >
                            <EditIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#003566",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="view" arrow>
                        <Link to={`/viewMasterProcedureFile/${item._id}`}>
                          <IconButton size="small">
                            <VisibilityIcon
                              style={{ fontSize: "1.4rem", color: "#003566" }}
                            />
                          </IconButton>
                        </Link>
                      </Tooltip>
                      {userType === 2 && (
                        <Tooltip title="Delete" arrow>
                          <IconButton
                            size="small"
                            style={{ marginLeft: "0.5rem" }}
                            onClick={() => handleDelete(item._id)}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "red",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          )}
        </Table>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            marginBottom: "4rem",
          }}
        >
          <Pagination
            count={totalPages}
            variant="outlined"
            shape="rounded"
            onChange={(e, number) => setPage(number)}
          />
        </div>
      </div>

      <Modal
        title={`${currentId != null ? "Edit" : "Add"} MASTER LIST OF PROCEDURE`}
        openPopup={openModal}
        closeModal={() => {
          setOpenModal(false);
        }}
      >
        <MasterProcedureInputs {...{ currentId, setOpenModal }} />
      </Modal>
      <DialogDelete isSubmitContent={true} />
    </section>
  );
};

export default MasterProcedureList;
